/**
 *  https://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=451224206
 */
import { md5Encrypt } from '@/utils/crypto'
import { requestCommonParams } from '@/lib/request/requestCommonParams'
import { getLocalStorage } from '@/utils/localStorage'

// 提单页INFO
export const BILL_INFO_TYPE = {
  REMINDER_INFO: 1,
  ADDRESS: 2,
  DELIVERY_METHOD: 3,
  PAY_CHANNEL: 4,
  ITEMS_INFO: 5,
  PRICE_INFO: 6,
  TIP_FEE: 7,
  REMARK: 8,
  SHOP_COUPON: 9,
  PLAT_COUPON: 10,
  FOLLOWING_INFO: 11,
  ALL_PRICE_INFO: 12,
  ABNORMAL_ITEM_OPT: 13,
  DISHE_SUBTOTAL: 14,
}

// 提单页 update
export const BILL_UPDATE_TYPE = {
  DELIVERY: 1,
  PAYMENT: 2,
  EDIT_DISHES: 3,
  DEL_DISHES: 4,
  MODIFY_TIP: 5,
  MODIFY_COMMENTS: 6,
  MODIFY_BUSINESS_COUPON: 7,
  MODIFY_PLATFORM_COUPON: 8,
  SELECT_COUPON_BOX: 9,
  DEFECT_INFO: 10,
}

// 提单页 组件ID
export const BILL_COMP_IDS = {
  SAVE_MONEY_INFO_ID: 501, // Spend X Save Y 组件
  PAY_DEDUCTION_ID: 506, // 支付立减组件id
}

// 提单页 preOrderId 生成规则：md5(uid+datatype+microtime)
export const getPreOrderId = () => {
  try {
    const { dataType } = requestCommonParams()
    const uid = getLocalStorage('uid') || ''
    const microtime = new Date().getTime()

    return md5Encrypt(uid + dataType + microtime)
  } catch (err) {}
}

// 提单后点击修改，修改的内容
export const AFTERCHECK_EDIT_TYPE = {
  EDIT_ADDRESS: 1, // 修改地址
  EDIT_DELIVERY: 2, // 修改见面方式
  EDIT_PAY: 3, // 修改支付方式
  EDIT_COM_ITEM: 4, // 修改菜品
  EDIT_TIPS: 5, // 修改小费
  EDIT_OTHER: -1, // 其他
}

export const billCheckInfo = {
  // 2:地址信息 3:见面方式 18:预计送达时间 4:支付方式
  ADDRESS_INFO: 2,
  DELIVERY_INFO: 3,
  ETA_INFO: 18,
  PAY_INFO: 4,
  DISHES_INFO: 5,
}
